var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa9d01;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono Documentos de Proyecto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cabecera"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 220,
    height: 275
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.7,238.25H167.23V217.18H188.3V64.63L154.46,30.8H53.77V51.87H32.7ZM155.88,39.1,180,63.21H155.88ZM58.64,35.66H151V68.07h32.41V212.32H58.64ZM37.57,56.73h16.2V217.18H162.36v16.21H37.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 101.59,
    y: 192.87,
    width: 64.83,
    height: 4.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 114.55,
    y: 179.9,
    width: 51.86,
    height: 4.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151,165.32h17.83V147.49H151Zm4.86-13H164v8.1h-8.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.62,
    y: 147.49,
    width: 51.86,
    height: 4.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.65,
    y: 160.45,
    width: 64.83,
    height: 4.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151,132.9h17.83V115.07H151Zm4.86-13H164V128h-8.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.62,
    y: 115.07,
    width: 51.86,
    height: 4.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.65,
    y: 128.04,
    width: 64.83,
    height: 4.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151,100.49h17.83V82.66H151Zm4.86-13H164v8.11h-8.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.62,
    y: 82.66,
    width: 51.86,
    height: 4.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.65,
    y: 95.63,
    width: 64.83,
    height: 4.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.62,
    y: 50.24,
    width: 51.86,
    height: 4.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.65,
    y: 63.21,
    width: 64.83,
    height: 4.86
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.d29461346a451e7e75f93b8671737ca7.svg";
export { ForwardRef as ReactComponent };